import { render, staticRenderFns } from "./BandejaFechaTextoComponente.vue?vue&type=template&id=47eef4c2"
import script from "./BandejaFechaTextoComponente.vue?vue&type=script&lang=js"
export * from "./BandejaFechaTextoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports